import { t } from "@/i18n-js/instance";
import { usePaywallFilterList } from "@circle-react/hooks/paywalls/usePaywallFilterList";
import { paywallTypes } from "@circle-react/types";
import { Filter } from "@circle-react-shared/FilterV3";
import { Loader } from "@circle-react-uikit/Loader";
import { ArrayFilterComparator } from "../../Filter/FilterTypes/ArrayFilterComparator/ArrayFilterComparator";
import {
  type ArrayComparatorParam,
  handleArrayComparatorApply,
} from "../../Filter/FilterTypes/ArrayFilterComparator/arrayComparators";
import { useArrayComparatorSelectedItem } from "../../Filter/FilterTypes/ArrayFilterComparator/useArrayComparatorSelectedItem";

const localeNamespace = "members_directory.header.search.filters.paywalls";

interface PaywallsFilterProps {
  isInitialOpen?: boolean;
  name: string;
  onApply?: (value: ArrayComparatorParam | null) => void;
  param: ArrayComparatorParam;
}

export const PaywallsFilter = ({
  name,
  isInitialOpen = false,
  onApply,
  param,
}: PaywallsFilterProps) => {
  const { paywalls, isPaywallsLoading } = usePaywallFilterList("paywalls", {
    type: [paywallTypes.space],
  });

  const renderSelectedValue = useArrayComparatorSelectedItem(paywalls);

  return (
    <Filter onApply={param => handleArrayComparatorApply(param, onApply)}>
      <Filter.Chip renderSelectedValue={() => renderSelectedValue(param)}>
        {t([localeNamespace, "singular_title"])}
      </Filter.Chip>

      <Filter.Popover
        title={t([localeNamespace, "title"])}
        isInitialOpen={isInitialOpen}
      >
        {isPaywallsLoading ? (
          <Loader />
        ) : (
          <ArrayFilterComparator name={name} options={paywalls} param={param} />
        )}
      </Filter.Popover>
    </Filter>
  );
};
